<template>
    <div class="common">
    </div>
</template>

<script>
    export default {
        name: 'Common',
    }
</script>

<style lang="scss" scoped>
.common {
    width: 620px;
}
</style>